
import { AuthForm } from "@/components/auth/AuthForm";
import { Link } from "react-router-dom";

const Signup = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center mb-8">
        <Link to="/">
          <img 
            src="/lovable-uploads/d62a4e07-f701-4335-84a0-c9be341a0477.png" 
            alt="Bright Stages" 
            className="h-24 md:h-28 lg:h-32 mx-auto mb-6 transition-all duration-300 hover:scale-105"
          />
        </Link>
        <p className="text-gray-600 text-lg">Start tracking your children's achievements today</p>
      </div>
      <AuthForm mode="signup" />
      <p className="mt-4 text-sm text-gray-600">
        Already have an account?{" "}
        <a href="/login" className="text-black font-bold hover:underline">
          Sign in
        </a>
      </p>
    </div>
  );
};

export default Signup;
